/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConversationDetails extends models.AgentFieldsBase {
    getFixupPrototypeFunction() { return ConversationDetails.fixupPrototype; }

    static newInstance(model: Partial<ConversationDetails>): ConversationDetails {
        let obj = Object.assign(new ConversationDetails(), model);
        ConversationDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConversationDetails>): ConversationDetails {
        if (!model) return null;
        return ConversationDetails.newInstance(<ConversationDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConversationDetails) {
        if (!obj) return;

        models.ConversationDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConversationDetails): boolean {
        if (models.AgentFieldsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ConversationDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.rating === undefined) {
            this.rating = 0;
        }
        if (this.agent_response) {
            models.AgentResponse.fixupPrototype(this.agent_response);
        }
        if (this.raw_response) {
            models.AgentResponse.fixupPrototype(this.raw_response);
        }
        if (this.revision_of) {
            models.RevisionTarget.fixupPrototype(this.revision_of);
        }
        if (this.annotations) {
            for (let val of this.annotations) {
                models.Annotation.fixupPrototype(val);
            }
        }
    }

    /**
     * ID of the chat
     */
    chat_id: string;

    /**
     * User query
     */
    user_query: string;

    /**
     * Response from the agent
     */
    agent_response: models.AgentResponse;

    /**
     * Pre-hardening structured agent response
     */
    raw_response: models.AgentResponse;

    /**
     * Rating of the query
     */
    rating: number;

    /**
     * Indicates if the conversation was interrupted
     */
    is_interrupted: boolean = false;

    /**
     * Indicates if the conversation was actionable
     */
    is_action_response: boolean = false;

    /**
     * ID of the user who authored the conversation
     */
    author_id: string;

    /**
     * Name of the user who authored the conversation
     */
    author_name: string;

    /**
     * Set when this turn revised a prior turn's block
     */
    revision_of: models.RevisionTarget;

    /**
     * Annotations the user sent with this revision turn
     */
    annotations: Array<models.Annotation>;

}
